import { withResizeDetector } from 'react-resize-detector'

export default withResizeDetector
